module.exports = __webpack_public_path__ + "assets/img/suport.d489f26b.svg";